import React from "react";
import { Dialog } from "@mui/material";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";

import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper";

const TestGroupDetailsDialog = ({
  open,
  closeDialog,
  testId,
  isMultiSet,
  hasCombinedSet,
  testGroupId,
}) => {
  const getSetLabel = (isMultiSet, hasCombinedSet) => {
    if (isMultiSet && hasCombinedSet) return "Multi-Set, Combined Result";
    if (isMultiSet) return "Multi-Set";
    if (hasCombinedSet) return "Combined Result";
    return "-";
  };

  return (
    <Dialog
      aria-label="Test Attachemnt Details"
      open={open}
      onClose={closeDialog}
      PaperProps={{
        sx: {
          minWidth: "300px",
          borderRadius: "12px",
          padding: "20px",
        },
      }}
    >
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0 text-bold">Test Details</h3>
        <IconButtonWrapper
          aria-label="Close the dialog"
          //   tabIndex="0"
          onClick={closeDialog}
        >
          <CrossIcon />
        </IconButtonWrapper>
      </div>

      <section className="d-flex flex-column">
        <div className="d-flex flex-column">
          <span>Test ID:</span>
          <h5 className="text-bold">{testId}</h5>
        </div>

        <div className="my-2 d-flex flex-column">
          <span>Type:</span>
          <h5 className="text-bold">
            {getSetLabel(isMultiSet, hasCombinedSet)}
          </h5>
        </div>

        <div className="d-flex flex-column">
          <span>Test Group ID:</span>
          <h5 className="text-bold">{testGroupId || "-"}</h5>
        </div>
      </section>
    </Dialog>
  );
};

export default TestGroupDetailsDialog;
